import {
  decryptAccountDataBundleFromRecords,
  encryptAccountDataBundle,
  type AccountDataBundle,
} from './accountDataSync';
import {
  accountFetch,
  type AccountSyncRecord,
  type PutAccountSyncRecordsInput,
} from './api.ts';

export async function uploadAccountDataBundle(
  token: string,
  bundle: AccountDataBundle,
  syncKey: CryptoKey,
): Promise<{ ok: boolean }> {
  const record = await encryptAccountDataBundle(bundle, syncKey);
  return accountFetch<{ ok: boolean }, PutAccountSyncRecordsInput>(
    '/account/sync-records',
    token,
    {
      method: 'PUT',
      body: { records: [record] },
    },
  );
}

export async function downloadAccountDataBundle(
  token: string,
  syncKey: CryptoKey,
): Promise<AccountDataBundle | undefined> {
  const body = await accountFetch<{ records: AccountSyncRecord[] }>(
    '/account/sync-records',
    token,
  );
  return decryptAccountDataBundleFromRecords(body.records, syncKey);
}
